import api from "./api";

export const getReportsGenerationAll = async(status?: string, date?: Date, plant?: string) => {
    const response = await api.get(`reportsGeneration/listAll?status=${status ? status : ""}&date=${date ? date : ""}&plant=${plant ? plant : ""}&orderby=data`);
    return response.data;
};

export const getReportsGenerationAllPagination = async(status?: string, date?: Date, plant?: string, plantName?: string, limit?: number, page?: number) => {
    const response = await api.get(`reportsGeneration/listAllPagination?status=${status ? status : ""}&date=${date ? date : ""}&plant=${plant ? plant : ""}${plantName && plantName !== "" ? `&plantName=${plantName}` : ""}&limit=${limit ? limit : ""}&page=${page ? page : ""}`);
    return response.data;
};

export const getReportsGenerationAllAnt = async(status: string, plant: string, dateAnt: any) => {
    const response = await api.get(`reportsGeneration/listAll?status=${status}&dateAnt=${dateAnt}&plant=${plant}`);
    return response.data;
};

export const getReportsGenerationOne = async(id: string) => {
    const response = await api.get(`reportsGeneration/${id}`);
    return response.data;
};

export const isReportNotFoundError = (error: any) => error?.response?.status === 404;

export const getReportsGenerationOnePublic = async(id: string) => {
    const response = await api.get(`reportsGeneration/listOnePage/${id}`);
    return response.data;
};

export const putReportsGenerationOne = async(id: string, data: any) => {
    const response = await api.put(`reportsGeneration/${id}`, data);
    return response.data;
};

export const putReportsGenerationGeneration = async(id: string, data: any) => {
    const response = await api.put(`reportsGeneration/updateStatusGeneration/${id}`, data);
    return response.data;
};


export const postReportGenerationEnviationEmail = async (body: any) => {
    const response = await api.post(`reportsGeneration/toSendReportsEmail/`, body);
    return response.data;
};
